import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { ProcumerentPlanItemParams } from 'types/api'
import { IPaginationQueryInfo } from 'types/pagination'
import {
  IProcurementPlanItem,
  IProcurementPlanItems,
} from 'types/procurementPlans/procurementPlanItems'

type GetProcurementPlanItemsInput = IPaginationQueryInfo & { id: string }

export const procurementPlanItemsApi = createApi({
  reducerPath: 'procurementPlanItems',
  baseQuery,
  endpoints: (builder) => ({
    procurementPlanItems: builder.query<
      IProcurementPlanItems,
      GetProcurementPlanItemsInput
    >({
      query: ({ id, size, page }) => {
        return {
          url: `/procurement-plans/${id}/items`,
          method: 'get',
          params: { size, page },
        }
      },
    }),

    procurementPlanItemsSearch: builder.query<
      IProcurementPlanItems,
      ProcumerentPlanItemParams
    >({
      query: ({ id, name, size, page }) => {
        const params = new URLSearchParams()
        if (size) {
          params.set('size', String(size))
        }
        if (page) {
          params.set('page', String(page))
        }

        if (name && name.length > 0) {
          params.set('name', name)
        }

        return {
          url: `/procurement-plans/${id}/items/search`,
          method: 'get',
          params,
        }
      },
    }),

    updateProcurementPlanItems: builder.mutation<
      IProcurementPlanItem,
      { id: string; planItem: IProcurementPlanItem }
    >({
      query: ({ id, planItem }) => ({
        url: `/procurement-plans/${id}/items`,
        body: planItem,
        method: 'put',
      }),
    }),

    createProcurementPlanItems: builder.mutation<
      IProcurementPlanItem,
      { id: string; planItem: IProcurementPlanItem }
    >({
      query: ({ id, planItem }) => ({
        url: `/procurement-plans/${id}/items`,
        method: 'post',
        body: planItem,
      }),
    }),

    deleteProcurementPlanItem: builder.mutation<
      void,
      { procumentPlanId: string; id: string }
    >({
      query: ({ procumentPlanId, id }) => ({
        url: `/procurement-plans/${procumentPlanId}/items/${id}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useProcurementPlanItemsQuery,
  useProcurementPlanItemsSearchQuery,
  useCreateProcurementPlanItemsMutation,
  useUpdateProcurementPlanItemsMutation,
  useDeleteProcurementPlanItemMutation,
} = procurementPlanItemsApi
